import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-template",
  "use": "icon-template-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-template\"><defs><style type=\"text/css\"></style></defs><path d=\"M80.2304 86.1696h870.4v307.2h-870.4zM541.0304 444.5696h409.6v491.52h-409.6zM80.2304 444.5696h409.6v220.16h-409.6zM80.2304 715.9296h409.6v220.16h-409.6z\" p-id=\"8668\">\n\n</path>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/template.svg
// module id = //Qc
// module chunks = 45